module.exports = __webpack_public_path__ + "static/media/ge.09dade9d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ge.svg
// module id = 2096
// module chunks = 0